import Image1 from '../../assets/testimonial1.png'
import Image2 from '../../assets/testimonial2.png'
import Image3 from '../../assets/testimonial3.png'
import Image4 from '../../assets/testimonial4.png'

export const Data = [
    {
        id: 1,
        image: Image1,
        title: "Pooja Mishra",
        description:
            "Parimal truly stands out as hardworking, knowledgeable, and dependable. His problem-solving skills, positive attitude, and team spirit make him a great asset to any organisation. He consistently brings deep expertise to his work, delivers high-quality results, and takes ownership of tasks with remarkable dedication. Looking forward to seeing all the great things he continues to achieve.",
    },
    {
        id: 2,
        image: Image2,
        title: "Mohini Holkar",
        description:
            "I had the pleasure of working with Parimal in survey programming, and his skills were integral to our success. His deep knowledge of survey design and programming, combined with his dedication to the work, ensured we consistently met our deadlines. Parimal was always proactive in troubleshooting and optimizing processes, making him a vital team member.",
    },
    {
        id: 3,
        image: Image3,
        title: "Jagannath Barik",
        description:
            "I had the privilege of working with Parimal Sawant during my tenure at Merkle, and I can confidently say he has been a constant source of support and guidance. He always encouraged me to learn and grow, never once making me feel that any task or knowledge was beyond my reach. His approachable nature, patience, and willingness to share his expertise made a significant difference in my professional journey. Parimal has truly been a guiding light, and it was a great experience working alongside him.",
    },
    {
        id: 4,
        image: Image4,
        title: "Jaysheel Mehta",
        description:
            "I had the privilege of working with Parimal Sawant during my tenure at Merkle, and I can confidently say he has been a constant source of support and guidance. He always encouraged me to learn and grow, never once making me feel that any task or knowledge was beyond my reach. His approachable nature, patience, and willingness to share his expertise made a significant difference in my professional journey. Parimal has truly been a guiding light, and it was a great experience working alongside him.",
    },
];